import { render, staticRenderFns } from "./UserDashboardTabs.vue?vue&type=template&id=89bdfdee&scoped=true&"
import script from "./UserDashboardTabs.vue?vue&type=script&lang=js&"
export * from "./UserDashboardTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bdfdee",
  null
  
)

export default component.exports